import type { SenderProps, Attachment } from './antdx';
import { UploadProps } from 'antd';
import { FunctionResponse } from './XAdkChatbot';

export interface SendContent {
  text?: string;
  files?: Attachment[] | any[];
  functionResponse?: FunctionResponse;
}

export interface XAiSenderProps extends Omit<SenderProps, 'onSubmit' | 'onCancel'> {
  /** 是否展示清空按钮 */
  clearBtnShow? : boolean;
  /** 底部文案 */
  footerTips?: string;
  /** 清空对话框按钮回调 */
  onClear?: () => void;
  /** 加载中，点击停止生成按钮回调 */
  onStop?: () => void;
  /** 点击发送按钮的回调 */
  onSubmit?: (content: SendContent) => void;
  /** 显示上传按钮 */
  enableUpload?: boolean;
  /** 文件列表 */
  files?: Attachment[];
  /** 文件列表变化 */
  onChangeFiles?: (files: Attachment[]) => void;
  /** 文件上传 */
  uploadRequest?: UploadProps['customRequest'];
}
